let activeRequests = 0;
let progressBarEl = null;
let hideTimeout = null;
let loadingSubscribers = new Set();

function notifySubscribers(isLoading) {
  loadingSubscribers.forEach((callback) => callback(isLoading));
}

function createProgressBar() {
  if (progressBarEl) return progressBarEl;

  progressBarEl = document.createElement('div');
  progressBarEl.id = 'global-progress-bar';
  progressBarEl.className = 'fixed top-0 left-0 h-1 bg-orange-500 transition-all duration-300 ease-out z-[9999]';
  progressBarEl.style.width = '0%';
  progressBarEl.style.opacity = '1';
  document.body.appendChild(progressBarEl);

  return progressBarEl;
}

function showProgress() {
  const bar = createProgressBar();
  bar.style.opacity = '1';
  bar.style.width = '30%';
}

function updateProgress() {
  if (!progressBarEl) return;
  progressBarEl.style.opacity = '1';
  progressBarEl.style.width = '80%';
}

function hideProgress() {
  if (!progressBarEl) return;

  if (hideTimeout) {
    clearTimeout(hideTimeout);
  }

  progressBarEl.style.width = '100%';

  hideTimeout = setTimeout(() => {
    if (progressBarEl) {
      progressBarEl.style.transition = 'opacity 0.2s ease-out';
      progressBarEl.style.opacity = '0';

      setTimeout(() => {
        if (progressBarEl && activeRequests === 0) {
          progressBarEl.style.width = '0%';
          progressBarEl.style.opacity = '1';
          progressBarEl.style.transition = 'all 0.3s ease-out';
        }
      }, 200);
    }
    hideTimeout = null;
  }, 300);
}

export function requestStarted() {
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  const wasEmpty = activeRequests === 0;
  activeRequests++;

  if (wasEmpty) {
    showProgress();
    notifySubscribers(true); // Notify loading started
  } else {
    updateProgress();
  }
}

export function requestEnded() {
  activeRequests = Math.max(activeRequests - 1, 0);
  if (activeRequests === 0) {
    hideProgress();
    notifySubscribers(false); // Notify loading ended
  }
}

export function subscribeToLoading(callback) {
  loadingSubscribers.add(callback);
  // Return unsubscribe function
  return () => {
    loadingSubscribers.delete(callback);
  };
}

export function getIsLoading() {
  return activeRequests > 0;
}

export function resetProgressBar() {
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }
  activeRequests = 0;
  notifySubscribers(false);
  if (progressBarEl) {
    progressBarEl.style.width = '0%';
    progressBarEl.style.opacity = '1';
    progressBarEl.style.transition = 'all 0.3s ease-out';
  }
}
